import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

const getBlockImg = (data) => ({
  name: data.name,
  className: 'img',
  children: {
    wrapper: {
      className: 'img-content',
    },
    img: {
      children: data.img,
    },
  },
});

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature17-wrapper',
    },
    page: {
      className: 'home-page feature17',
    },
    OverPack: {
      playScale: 0.3,
    },
    titleWrapper: {
      className: 'feature17-title-wrapper',
      children: [
        {
          name: 'title',
          className: 'feature17-title-h1',
          children: '现代服务业',
        },
      ],
    },
    blockWrapper: {
      className: 'feature17-block-wrapper',
      gutter: 24,
      children: [
        {
          md: 8,
          xs: 24,
          name: 'block1',
          className: 'feature17-block',
          children: {
            className: 'feature17-block-group feature17-block-group1',
            children: [
              {
                name: 'image',
                className: 'feature17-block-image',
                children: 'https://imm.86links.com/assets/landing/feature/Feature17-img/icon-1.png',
              },
              {
                name: 'title',
                className: 'feature17-block-title',
                children: '总部经济',
              },
              {
                name: 'content',
                className: 'feature17-block-content',
                children: '聚集一大批知名总部企业，建成经开孵化园、百悦国际中心等总部经济楼宇（园区）载体，快速构建总部经济生态圈。',
              },
            ],
          },
        },
        {
          md: 8,
          xs: 24,
          name: 'block2',
          className: 'feature17-block',
          children: {
            className: 'feature17-block-group feature17-block-group2',
            children: [
              {
                name: 'image',
                className: 'feature17-block-image',
                children: 'https://imm.86links.com/assets/landing/feature/Feature17-img/icon-2.png',
              },
              {
                name: 'title',
                className: 'feature17-block-title',
                children: '现代文旅产业',
              },
              {
                name: 'content',
                className: 'feature17-block-content',
                children: '整合区域特色文化资源优势，初步形成以梵木创艺区、中国艺库为核心的六大文创产业园区。',
              },
            ],
          },
        },
        {
          md: 8,
          xs: 24,
          name: 'block3',
          className: 'feature17-block',
          children: {
            className: 'feature17-block-group feature17-block-group3',
            children: [
              {
                name: 'image',
                className: 'feature17-block-image',
                children: 'https://imm.86links.com/assets/landing/feature/Feature17-img/icon-3.png',
              },
              {
                name: 'title',
                className: 'feature17-block-title',
                children: '商贸物流',
              },
              {
                name: 'content',
                className: 'feature17-block-content',
                children: '大力发展与高端服务业相关的各类产业，加速形成功能丰富的现代服务与物流业聚集发展体系。',
              },
            ],
          },
        },
      ],
    },
    img: {
      className: 'img-wrapper',
      children: [
        getBlockImg(
          {
            name: 'block0',
            img: 'https://imm.86links.com/assets/landing/feature/Feature16-img/bottom-1.png',
          }
        ),
        getBlockImg(
          {
            name: 'block1',
            img: 'https://imm.86links.com/assets/landing/feature/Feature16-img/bottom-2.png',
          }
        ),
        getBlockImg(
          {
            name: 'block2',
            img: 'https://imm.86links.com/assets/landing/feature/Feature16-img/bottom-3.png',
          }
        ),
      ],
    },
  },
};
